<div class="flex flex-wrap max-w-7xl mx-auto mt-8">

    <div class="w-full flex justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        @if((myRoles$ | async)?.admin && (group$ | async)?.memberStatus ==
        membershipStatus.active
        ) {
        <app-btn-route btnText="New Event" routeTo="create" icon="fa fa-add"
            colors="bg-primary-500 hover:bg-primary-300"></app-btn-route>
        }
    </div>

    <h1 class="font-semibold text-2xl text-primary-500 mb-4">
        Events
    </h1>

    @let group = group$ | async;
    @let eventStatsLoading = eventStatsLoading$ | async;

    @if(group) {
    <div class="flex flex-row gap-4 w-full mb-4">
        <div class="w-full md:w-4/12 bg-white rounded-lg shadow-lg px-4 py-2 flex flex-col gap-2 justify-between">
            <span class="w-full text-start text-sm text-blueGray-400">Total Active Events</span>
            @if(eventStatsLoading) {
            <div class="animate-pulse h-8 w-1/2 bg-slate-200 rounded-lg flex justify-end"></div>
            } @else {
            <div class="flex flex-row justify-end gap-1">
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group.activeEvents ?? '-'}}</span>
            </div>
            }
        </div>
        <div class="w-full md:w-4/12 bg-white rounded-lg shadow-lg px-4 py-2 flex flex-wrap gap-2 justify-between">
            <span class="text-sm text-blueGray-400 block">Completed (last 30 days)</span>
            @if(eventStatsLoading) {
            <div class="animate-pulse h-8 w-1/2 bg-slate-200 rounded-lg flex justify-end"></div>
            } @else {
            <div class="flex flex-row w-full justify-end justify-items-end gap-1">
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group.completedEvents ??
                    '-'}}</span>
            </div>
            }
        </div>
    </div>
    }

    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white">
        <app-calendar [events$]="events$" [loading$]="eventsLoading$" [group]="group$ | async"
            [isAdmin]="(myRoles$ | async)?.admin && (group$ | async)?.memberStatus == membershipStatus.active"
            (selectedMonthChange)="onDateChange($event)"></app-calendar>
    </div>
</div>